import {
  observable,
  action,
} from 'mobx';
import {
  CustomScreenNames,
  CustomScreen,
  AvailableCountry,
  WidgetKeys,
} from 'mobx-store/stores/customScreens/types';
import Connections from 'connections';
import {
  CustomScreensStore,
} from '..';
import {
  getCustomScreen,
  createCustomScreens,
  getCustomScreens,
  updateCustomScreens,
  getWidgets,
} from './requests';
import {
  RequestStatus,
} from 'mobx-store';
import { uploadImageFromURI } from 'helperFunctions/uploadService';
import { getHeader } from 'helperFunctions/getHeader';
import { ScreenAPI } from 'screens/addEditCustomScreen/widgets/constants';
import {
  ICountry,
} from '../../../storeInterfaces/authInterface';
import { convertCountriesToISOCodeString } from 'constants/countries';

class CustomScreens {
  customScreensStore: CustomScreensStore;

  @observable customScreen: CustomScreen = {} as CustomScreen;
  @observable customScreens: CustomScreen[] = [];

  @observable requestStatus: RequestStatus = RequestStatus.IDLE;
  @observable createOrUpdaterequestStatus: RequestStatus = RequestStatus.IDLE;

  @observable screensListStatus: RequestStatus = RequestStatus.IDLE;
  @observable screensList: { title: string, id: string }[] = [];

  @observable widgetKeys: WidgetKeys[] = [];
  constructor(customScreensStore: CustomScreensStore) {
    this.customScreensStore = customScreensStore;
  }


  @action
  getScreensList = async (api: ScreenAPI) => {
    try {
      const response = await Connections.wadiDeglaAxios.httpGet(api);
      this.screensList = this.formatScreensList(api, response.data);
      Promise.resolve(true);
    } catch (error) {
      console.log('error', error)
      Promise.reject(error);
    }
  };
  @action
  getCustomScreen = async (customScreenName: string, language: string) => {
    try {
      this.requestStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(getCustomScreen(customScreenName), getHeader(language));
      this.customScreen = response.data;
      this.requestStatus = RequestStatus.SUCCESS;
      Promise.resolve(this.customScreen);
    } catch (err) {
      Promise.reject(err);
      this.requestStatus = RequestStatus.FAILED;
    }
  };

  @action
  getCustomScreens = async (countries: ICountry[]) => {
    try {
      this.requestStatus = RequestStatus.LOADING;

      const availableCountries = convertCountriesToISOCodeString(countries);
      const params = {
        availableCountries,
      };
      const config = {
        params,
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getCustomScreens, config);
      this.customScreens = response.data;
      this.requestStatus = RequestStatus.SUCCESS;
      Promise.resolve(this.customScreen);
    } catch (error) {
      Promise.reject(error);
      this.requestStatus = RequestStatus.FAILED;
    }
  }

  @action
  createCustomScreen = async (customScreenData: CustomScreen, language: string, countries: ICountry[]): Promise<String | undefined> => {
    try {
      this.createOrUpdaterequestStatus = RequestStatus.LOADING;

      const newCustomScreenData = await this.restructureCustomScreen(customScreenData);
      
      const availableCountries: AvailableCountry[] = []; 
      countries.map((country: ICountry) => { availableCountries.push({countryId: country.countryId}); });
      newCustomScreenData.availableCountries = availableCountries;

      const response = await Connections.wadiDeglaAxios.httpPost(createCustomScreens, newCustomScreenData, getHeader(language));
      this.createOrUpdaterequestStatus = RequestStatus.SUCCESS;
      return response.data;
    } catch (error) {
      Promise.reject(error);
      this.createOrUpdaterequestStatus = RequestStatus.FAILED;
    }
  }

  @action
  updateCustomScreen = async (customScreenData: CustomScreen, language: string) => {
    try {
      this.createOrUpdaterequestStatus = RequestStatus.LOADING;
      const newCustomScreenData = await this.restructureCustomScreen(customScreenData);
      const response = await Connections.wadiDeglaAxios.httpPut(updateCustomScreens, newCustomScreenData, getHeader(language));
      this.createOrUpdaterequestStatus = RequestStatus.SUCCESS;
      Promise.resolve(response.data);
    } catch (error) {
      Promise.reject(error);
      this.createOrUpdaterequestStatus = RequestStatus.FAILED;
    }
  }

  private async getWidgetParams(params: any) {
    if (params.hasOwnProperty('data')) {
      let sliderWidgetData = JSON.parse(params.data) as any[];

      for (const swd of sliderWidgetData) {
        if (swd?.params?.imageURL) {
          swd.params.imageURL = await uploadImageFromURI(swd.params.imageURL);
        }
        if(swd?.params?.iconImage) {
          swd.params.iconImage = await uploadImageFromURI(swd.params.iconImage);
        }
        if(swd?.params?.textImage) {
          swd.params.textImage = await uploadImageFromURI(swd.params.textImage);
        }
      };
      params.data = JSON.stringify(sliderWidgetData);
    }

    return {
      ...params,
      imageURL: params.imageURL ? await uploadImageFromURI(params.imageURL) : '',
      iconImage: params.iconImage ? await uploadImageFromURI(params.iconImage) : '',
      textImage: params.textImage ? await uploadImageFromURI(params.textImage) : '',
    }
  }
  

  private restructureCustomScreen = async (customScreen: CustomScreen): Promise<CustomScreen> => {
    return {
      ...customScreen,
      widgetInstances: await Promise.all(
        customScreen.widgetInstances.map(async (instance) => {
          return {
            ...instance,
            widgetInstanceId: instance.widgetInstanceId.toString().startsWith('UNTRACKED') ? (undefined as any) : Number(instance.widgetInstanceId),
            params: await this.getWidgetParams(instance.params)
          }
        }))
    }
  }

  formatScreensList(type: ScreenAPI, object: any) {
    switch (type) {
      case ScreenAPI.BRANCH:
        return this.getMapedResponseScreenList('title', 'branchId', object);
      case ScreenAPI.OFFERS:
        return this.getMapedResponseScreenList('title', 'offerId' , object);
      case ScreenAPI.PARTNERS:
        return this.getMapedResponseScreenList('name', 'deglawyPartnerId' , object);
      case ScreenAPI.ACADEMIES:
        return this.getMapedResponseScreenList('title', 'academyId' , object);
      case ScreenAPI.ARTICLES:
        return this.getMapedResponseScreenList('title', 'articleId' , object);
      case ScreenAPI.TROPHIES:
        return this.getMapedResponseScreenList('title', 'deglawyTrophyId', object);
      case ScreenAPI.FEATURES:
        return this.getMapedResponseScreenList('title','deglawyFeaturedId',object);
      case ScreenAPI.WHEEL:
        return this.getMapedResponseScreenList('title','eventId',object);
      default: 
        return [];
    }
  }
  getMapedResponseScreenList(title: string, id: string, list: {[key: string]: string}[]) {
    return list.map(l => {
      return {
        title: l[title],
        id: l[id]
      };
    });
  }

  @action
  getWidgets = async (countries: ICountry[]) => {
    try {
      this.requestStatus = RequestStatus.LOADING;

      const availableCountries = convertCountriesToISOCodeString(countries);
      const params = {
        availableCountries,
      };
      const config = {
        params,
      };

      const response = await Connections.wadiDeglaAxios.httpGet(getWidgets, config);
      this.widgetKeys = [];
      response.data.map((widget: any)=>{
        this.widgetKeys.push(widget.widgetKey);
      });
      this.requestStatus = RequestStatus.SUCCESS;
      Promise.resolve(this.customScreen);
    } catch (error) {
      Promise.reject(error);
      this.requestStatus = RequestStatus.FAILED;
    }
  }

}

export default CustomScreens;
